(function($) {
  'use strict';

  // Neutralize theme's old destructive DOM-moving, obsolete sticky & mini-cart functions
  if (window.novtheme) {
    window.novtheme.toggleSticky = function() {};
    window.novtheme.eventBlockCart = function() {};
    window.novtheme.StickyHeader = function() {};
  }

  // Slide-out Cart Drawer Manager
  var CustomCartDrawer = {
    isOpen: false,
    shippingThreshold: 10000, // $100.00 in cents

    init: function() {
      var self = this;
      var $thresholdEl = $('.cart-drawer__shipping-bar');
      if ($thresholdEl.length && $thresholdEl.data('threshold')) {
        self.shippingThreshold = parseInt($thresholdEl.data('threshold'), 10) || 10000;
      }
      self.bindEvents();
      self.interceptAddCart();
    },

    open: function() {
      this.isOpen = true;
      $('#CartDrawer').addClass('is-open').attr('aria-hidden', 'false');
      $('body').css('overflow', 'hidden');
    },

    close: function() {
      this.isOpen = false;
      $('#CartDrawer').removeClass('is-open').attr('aria-hidden', 'true');
      $('body').css('overflow', '');
    },

    formatMoney: function(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        var format = (typeof theme !== 'undefined' && (theme.moneyFormat || theme.money_format)) || window.money_format || '${{amount}}';
        try {
          return Shopify.formatMoney(cents, format);
        } catch(e) {}
      }
      return '$' + (cents / 100).toFixed(2);
    },

    escapeHtml: function(text) {
      if (!text) return '';
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    },

    renderCart: function(cart) {
      var self = this;
      if (!cart) return;

      var count = cart.item_count || 0;

      // Update all cart count badges in desktop header, mobile header, drawer
      $('.CartCount, #CartCountCavas, .cart-products-count span').text(count);
      $('.cart-count').each(function() {
        $(this).find('.CartCount').text(count);
      });
      $('.site-header__cart-count .CartCount').text(count);

      // Update Free Shipping Bar
      var total = cart.total_price || 0;
      var $bar = $('.cart-drawer__shipping-bar');
      if ($bar.length) {
        if (total >= self.shippingThreshold) {
          $bar.html('<p class="shipping-bar__message success">You qualify for <strong>FREE SHIPPING!</strong></p>' +
                    '<div class="shipping-bar__progress"><div class="shipping-bar__meter" style="width: 100%;"></div></div>');
        } else {
          var diff = self.shippingThreshold - total;
          var percent = Math.min(100, Math.round((total / self.shippingThreshold) * 100));
          $bar.html('<p class="shipping-bar__message">Add <strong>' + self.formatMoney(diff) + '</strong> more to enjoy <strong>FREE SHIPPING!</strong></p>' +
                    '<div class="shipping-bar__progress"><div class="shipping-bar__meter" style="width: ' + percent + '%;"></div></div>');
        }
      }

      // Render Line Items or Empty State
      var $itemsWrapper = $('.cart-drawer__items-wrapper');
      var $itemsContainer = $('[data-cart-items]');
      var $emptyState = $('.cart-drawer__empty');
      var $footer = $('.cart-drawer__footer');
      var $subtotal = $('[data-cart-subtotal]');

      if (count === 0 || !cart.items || cart.items.length === 0) {
        $itemsWrapper.hide();
        $footer.hide();
        $emptyState.show();
      } else {
        $emptyState.hide();
        $itemsWrapper.show();
        $footer.show();

        $subtotal.text(self.formatMoney(total));

        var html = '';
        cart.items.forEach(function(item, index) {
          var lineIndex = index + 1;
          var itemImg = item.image ? item.image : (item.featured_image ? (item.featured_image.url || item.featured_image) : '');
          var itemTitle = self.escapeHtml(item.product_title || item.title);
          var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? self.escapeHtml(item.variant_title) : '';
          var itemPrice = self.formatMoney(item.final_price || item.price);
          var itemUrl = item.url || '/products/' + item.handle;

          html += '<div class="cart-item" data-line="' + lineIndex + '" data-key="' + item.key + '">';
          html += '  <div class="cart-item__image">';
          html += '    <a href="' + itemUrl + '">';
          if (itemImg) {
            html += '      <img src="' + itemImg + '" alt="' + itemTitle + '" width="80" height="80" loading="lazy">';
          }
          html += '    </a>';
          html += '  </div>';
          html += '  <div class="cart-item__details">';
          html += '    <a href="' + itemUrl + '" class="cart-item__title">' + itemTitle + '</a>';
          if (variantTitle) {
            html += '    <div class="cart-item__variant">' + variantTitle + '</div>';
          }
          html += '    <div class="cart-item__price"><span>' + itemPrice + '</span></div>';
          html += '    <div class="cart-item__actions d-flex align-items-center justify-content-between">';
          html += '      <div class="cart-item__quantity d-inline-flex align-items-center">';
          html += '        <button type="button" class="qty-btn qty-minus pointer" data-qty-change="-1" data-line="' + lineIndex + '" aria-label="Decrease quantity">−</button>';
          html += '        <input type="number" class="qty-input" value="' + item.quantity + '" min="1" readonly data-line="' + lineIndex + '" aria-label="Quantity">';
          html += '        <button type="button" class="qty-btn qty-plus pointer" data-qty-change="1" data-line="' + lineIndex + '" aria-label="Increase quantity">+</button>';
          html += '      </div>';
          html += '<button type="button" class="cart-item__remove pointer" data-line="' + lineIndex + '" aria-label="Remove item" style="opacity:1;">';
          html += '  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="16px" height="16px" fill="#6b6b6b" style="display:block;" onmouseover="this.style.fill=\'#e03131\'" onmouseout="this.style.fill=\'#6b6b6b\'">';
          html += '    <path d="M 46 13 C 44.35503 13 43 14.35503 43 16 L 43 18 L 32.265625 18 C 30.510922 18 28.879517 18.922811 27.976562 20.427734 L 26.433594 23 L 23 23 C 20.802666 23 19 24.802666 19 27 C 19 29.197334 20.802666 31 23 31 L 24.074219 31 L 27.648438 77.458984 C 27.88773 80.575775 30.504529 83 33.630859 83 L 66.369141 83 C 69.495471 83 72.11227 80.575775 72.351562 77.458984 L 75.925781 31 L 77 31 C 79.197334 31 81 29.197334 81 27 C 81 24.802666 79.197334 23 77 23 L 73.566406 23 L 72.023438 20.427734 C 71.120481 18.922811 69.489078 18 67.734375 18 L 57 18 L 57 16 C 57 14.35503 55.64497 13 54 13 L 46 13 z M 46 15 L 54 15 C 54.56503 15 55 15.43497 55 16 L 55 18 L 45 18 L 45 16 C 45 15.43497 45.43497 15 46 15 z M 32.265625 20 L 43.832031 20 A 1.0001 1.0001 0 0 0 44.158203 20 L 55.832031 20 A 1.0001 1.0001 0 0 0 56.158203 20 L 67.734375 20 C 68.789672 20 69.763595 20.551955 70.306641 21.457031 L 71.833984 24 L 68.5 24 A 0.50005 0.50005 0 1 0 68.5 25 L 73.5 25 L 77 25 C 78.116666 25 79 25.883334 79 27 C 79 28.116666 78.116666 29 77 29 L 23 29 C 21.883334 29 21 28.116666 21 27 C 21 25.883334 21.883334 25 23 25 L 27 25 L 61.5 25 A 0.50005 0.50005 0 1 0 61.5 24 L 28.166016 24 L 29.693359 21.457031 C 30.236405 20.551955 31.210328 20 32.265625 20 z M 64.5 24 A 0.50005 0.50005 0 1 0 64.5 25 L 66.5 25 A 0.50005 0.50005 0 1 0 66.5 24 L 64.5 24 z M 26.078125 31 L 73.921875 31 L 70.357422 77.306641 C 70.196715 79.39985 68.46881 81 66.369141 81 L 33.630859 81 C 31.53119 81 29.803285 79.39985 29.642578 77.306641 L 26.078125 31 z M 38 35 C 36.348906 35 35 36.348906 35 38 L 35 73 C 35 74.651094 36.348906 76 38 76 C 39.651094 76 41 74.651094 41 73 L 41 38 C 41 36.348906 39.651094 35 38 35 z M 50 35 C 48.348906 35 47 36.348906 47 38 L 47 73 C 47 74.651094 48.348906 76 50 76 C 51.651094 76 53 74.651094 53 73 L 53 69.5 A 0.50005 0.50005 0 1 0 52 69.5 L 52 73 C 52 74.110906 51.110906 75 50 75 C 48.889094 75 48 74.110906 48 73 L 48 38 C 48 36.889094 48.889094 36 50 36 C 51.110906 36 52 36.889094 52 38 L 52 63.5 A 0.50005 0.50005 0 1 0 53 63.5 L 53 38 C 53 36.348906 51.651094 35 50 35 z M 62 35 C 60.348906 35 59 36.348906 59 38 L 59 39.5 A 0.50005 0.50005 0 1 0 60 39.5 L 60 38 C 60 36.889094 60.889094 36 62 36 C 63.110906 36 64 36.889094 64 38 L 64 73 C 64 74.110906 63.110906 75 62 75 C 60.889094 75 60 74.110906 60 73 L 60 47.5 A 0.50005 0.50005 0 1 0 59 47.5 L 59 73 C 59 74.651094 60.348906 76 62 76 C 63.651094 76 65 74.651094 65 73 L 65 38 C 65 36.348906 63.651094 35 62 35 z M 38 36 C 39.110906 36 40 36.889094 40 38 L 40 73 C 40 74.110906 39.110906 75 38 75 C 36.889094 75 36 74.110906 36 73 L 36 38 C 36 36.889094 36.889094 36 38 36 z M 59.492188 41.992188 A 0.50005 0.50005 0 0 0 59 42.5 L 59 44.5 A 0.50005 0.50005 0 1 0 60 44.5 L 60 42.5 A 0.50005 0.50005 0 0 0 59.492188 41.992188 z"/>';
          html += '  </svg>';
          html += '</button>';
          html += '    </div>';
          html += '  </div>';
          html += '</div>';
        });
        $itemsContainer.html(html);
      }
    },

    refresh: function(shouldOpen) {
      var self = this;
      fetch('/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function(res) {
        return res.json();
      })
      .then(function(cart) {
        self.renderCart(cart);
        if (shouldOpen) {
          self.open();
        }
      })
      .catch(function(err) {
        console.error('Failed to fetch cart:', err);
      });
    },

    updateQty: function(line, newQty) {
      var self = this;
      var $panel = $('.cart-drawer__panel');
      $panel.css('opacity', '0.6').css('pointer-events', 'none');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ line: line, quantity: newQty })
      })
      .then(function(res) {
        return res.json();
      })
      .then(function(cart) {
        self.renderCart(cart);
      })
      .catch(function(err) {
        console.error('Cart update error:', err);
      })
      .finally(function() {
        $panel.css('opacity', '1').css('pointer-events', 'auto');
      });
    },

    bindEvents: function() {
      var self = this;

      // Cart Trigger buttons
      $(document).off('click.customCartTrigger', '[data-cart-trigger], .header-cart, .contentsticky_cart, .site-header__cart')
        .on('click.customCartTrigger', '[data-cart-trigger], .header-cart, .contentsticky_cart, .site-header__cart', function(e) {
          if ($(e.target).closest('#CartDrawer').length) return;
          e.preventDefault();
          e.stopPropagation();
          self.refresh(true);
        });

      // Cart Close buttons & Overlay
      $(document).off('click.customCartClose', '[data-cart-close]')
        .on('click.customCartClose', '[data-cart-close]', function(e) {
          e.preventDefault();
          self.close();
        });

      // Escape key to close
      $(document).off('keydown.customCartEsc')
        .on('keydown.customCartEsc', function(e) {
          if (e.key === 'Escape' || e.keyCode === 27) {
            if (self.isOpen) {
              self.close();
            }
            $('.nov-search__canvas').removeClass('act');
            $('[data-toggle="search_canvas"]').removeClass('act');
          }
        });

      // Quantity change buttons inside drawer
      $(document).off('click.customCartQty', '[data-qty-change]')
        .on('click.customCartQty', '[data-qty-change]', function(e) {
          e.preventDefault();
          var $btn = $(this);
          var change = parseInt($btn.data('qty-change'), 10) || 0;
          var line = $btn.data('line') || $btn.siblings('.qty-input').data('line');
          var $input = $btn.siblings('.qty-input');
          var currentVal = parseInt($input.val(), 10) || 1;
          var newVal = currentVal + change;
          if (newVal >= 0 && line) {
            self.updateQty(line, newVal);
          }
        });

      // Remove item buttons inside drawer
      $(document).off('click.customCartRemove', '.cart-item__remove')
        .on('click.customCartRemove', '.cart-item__remove', function(e) {
          e.preventDefault();
          var line = $(this).data('line');
          if (line) {
            self.updateQty(line, 0);
          }
        });
    },

    interceptAddCart: function() {
      var self = this;

      // Intercept window.fetch for /cart/add
      var originalFetch = window.fetch;
      window.fetch = function() {
        var args = arguments;
        var url = args[0];
        var isAddCart = false;

        if (typeof url === 'string') {
          isAddCart = url.indexOf('/cart/add') !== -1;
        } else if (url && url.url) {
          isAddCart = url.url.indexOf('/cart/add') !== -1;
        }

        return originalFetch.apply(this, args).then(function(response) {
          if (isAddCart && response.ok && !window._cartAddHandling) {
            self.refresh(true);
          }
          return response;
        });
      };

      // Intercept jQuery AJAX for /cart/add
      $(document).ajaxComplete(function(event, xhr, settings) {
        if (settings && settings.url && settings.url.indexOf('/cart/add') !== -1 && !window._cartAddHandling) {
          self.refresh(true);
        }
      });

      // Hook Alpine cart store if it initializes
      function hookAlpine() {
        if (window.Alpine && Alpine.store) {
          try {
            var cartStore = Alpine.store('cart');
            if (cartStore && !cartStore.__customHooked) {
              cartStore.__customHooked = true;
              var origShowCart = cartStore.showCart;
              cartStore.showCart = function() {
                self.refresh(true);
                if (typeof origShowCart === 'function') {
                  try { origShowCart.apply(this, arguments); } catch(e) {}
                }
              };
            }
          } catch(e) {}
        }
      }
      hookAlpine();
      document.addEventListener('alpine:init', hookAlpine);
      document.addEventListener('alpine:initialized', hookAlpine);
    }
  };

  window.CustomCartDrawer = CustomCartDrawer;

  // ----------------------------------------------------------------------
  // In-page anchor links (menu -> section id) with fixed-header offset
  // ----------------------------------------------------------------------
  function scrollToHash(hash, smooth) {
    if (!hash || hash.length < 2) return false;
    var target;
    try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (e) { return false; }
    if (!target) return false;
    var hdr = document.querySelector('.site-header.sticky-header');
    var offset = hdr ? hdr.getBoundingClientRect().bottom + 10 : 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
    return true;
  }

  function closeMobileMenu() {
    $('#show-megamenu').removeClass('act');
    $('body').css('overflow', '');
    $('.sidebar-overlay').add('#mobile_menu').removeClass('act').css('z-index', '99');
  }

    document.addEventListener('click', function(e) {
    var a = e.target.closest && e.target.closest('#AccessibleNav a, #mobile_menu a');
    if (!a || !a.hash || a.hash.length < 2) return;
    if (a.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) return;
    var id;
    try { id = decodeURIComponent(a.hash.slice(1)); } catch (err) { return; }
    if (!document.getElementById(id)) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    closeMobileMenu();
    if (window.history && history.pushState) history.pushState(null, '', a.hash);
    setTimeout(function() { scrollToHash(a.hash, true); }, 60);
  }, true);

  // Page load-e hash thakle (onno page theke asle) offset soho scroll
  $(window).off('load.customAnchor').on('load.customAnchor', function() {
    if (window.location.hash) {
      setTimeout(function() { scrollToHash(window.location.hash, false); }, 250);
    }
  });

  function initHeader(container) {
    var $scope = $(container || document);
    var $siteHeader = $scope.find('.site-header');
    if (!$siteHeader.length) $siteHeader = $('.site-header');

    // ----------------------------------------------------------------------
    // Always-sticky header: reserve space + shadow on scroll
    // ----------------------------------------------------------------------
    var $mainHeader = $('.site-header.sticky-header').first();

    function syncHeaderHeight() {
      if (!$mainHeader.length) return;
      var h = $mainHeader.outerHeight() || 0;
      document.documentElement.style.setProperty('--header-h', h + 'px');
      // Homepage: header overlays the hero, so no space needed.
      // Other pages: push content down so it doesn't hide behind the fixed header.
      var isHome = $mainHeader.closest('.template-index').length > 0;
      $mainHeader.closest('.shopify-section').css('min-height', isHome ? '' : h + 'px');
    }

    syncHeaderHeight();
    $(window).off('resize.customHeaderH load.customHeaderH').on('resize.customHeaderH load.customHeaderH', syncHeaderHeight);

    if (window.ResizeObserver && $mainHeader.length && !$mainHeader.data('ro-inited')) {
      $mainHeader.data('ro-inited', true);
      new ResizeObserver(syncHeaderHeight).observe($mainHeader[0]);
    }

    $(window).off('scroll.customHeaderShadow').on('scroll.customHeaderShadow', function() {
      $mainHeader.toggleClass('is-scrolled', window.pageYOffset > 10);
    });

    // Desktop Search Canvas Toggle
    $(document).off('click.customSearchToggle', '[data-toggle="search_canvas"]')
      .on('click.customSearchToggle', '[data-toggle="search_canvas"]', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var $searchCanvas = $('.nov-search__canvas');

        if ($searchCanvas.hasClass('act')) {
          $searchCanvas.removeClass('act');
          $('[data-toggle="search_canvas"]').removeClass('act');
        } else {
          var hdr = $('.site-header.sticky-header').first()[0];
          if (hdr) {
            $searchCanvas.css('top', Math.round(hdr.getBoundingClientRect().bottom) + 'px');
          }
          $searchCanvas.addClass('act');
          $('[data-toggle="search_canvas"]').addClass('act');
          setTimeout(function() {
            $searchCanvas.find('.search-header__input').focus();
          }, 100);
        }
      });

    $(document).off('click.customSearchClose', '[data-close="search_canvas"]')
      .on('click.customSearchClose', '[data-close="search_canvas"]', function(e) {
        e.preventDefault();
        $('.nov-search__canvas').removeClass('act');
        $('[data-toggle="search_canvas"]').removeClass('act');
      });

    $(document).off('click.customSearchOutside')
      .on('click.customSearchOutside', function(e) {
        if (!$(e.target).closest('.nov-search__canvas, [data-toggle="search_canvas"]').length) {
          $('.nov-search__canvas').removeClass('act');
          $('[data-toggle="search_canvas"]').removeClass('act');
        }
      });

    // Mobile Navigation Drawer Toggle
    $('#show-megamenu').off('click.customHeader').on('click.customHeader', function(e) {
      e.preventDefault();
      var $this = $(this);
      var $mobileMenu = $('#mobile_menu');
      var $overlay = $('.sidebar-overlay');
      if ($this.hasClass('act')) {
        $this.removeClass('act');
        $('body').css('overflow', 'auto');
        $overlay.add($mobileMenu).removeClass('act').css('z-index', '99');
      } else {
        $this.addClass('act');
        $('body').css('overflow', 'hidden');
        $overlay.add($mobileMenu).addClass('act').css('z-index', '100');
      }
    });

    // Close mobile off-canvas menu (overlay click / close button)
    $(document).off('click.customMobileMenuClose', '[data-close="mobile_menu"]')
      .on('click.customMobileMenuClose', '[data-close="mobile_menu"]', function(e) {
        e.preventDefault();
        $('#show-megamenu').removeClass('act');
        $('body').css('overflow', 'auto');
        $('.sidebar-overlay').add('#mobile_menu').removeClass('act').css('z-index', '99');
      });

    // Expand/collapse submenus inside mobile menu
    $(document).off('click.customMobileSubmenu', '#mobile_menu .parent--lv1 > .site-nav__link--main')
      .on('click.customMobileSubmenu', '#mobile_menu .parent--lv1 > .site-nav__link--main', function(e) {
        e.preventDefault();
        $(this).closest('.parent--lv1').toggleClass('act');
      });

    // Mobile Search Toggle
    $('.mobile-btn_search').off('click.customHeader').on('click.customHeader', function(e) {
      e.preventDefault();
      $(this).toggleClass('act');
      $('#mobile_search').toggleClass('act');
    });

    $('.search_overlay').off('click.customHeader').on('click.customHeader', function() {
      $('#mobile_search, .mobile-btn_search').removeClass('act');
    });

    // Initialize Cart Drawer
    CustomCartDrawer.init();
  }

  $(document).ready(function() {
    initHeader(document);
  });

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.classList.contains('shopify-section-header') || e.target.querySelector('.site-header')) {
      initHeader(e.target);
    }
  });

})(window.jQuery || window.$);